module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý bảng giá"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-price-table'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm\n      mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.priceTables,
    attrs: {
      "table-name": _vm.priceTables,
      "data-source": "price-tables",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "row-class-name": _vm.tableRowClassName,
            "border": ""
          }
        }, [_vm._v("\n          >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.priceTables]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.priceTables].current_page - 1) * _vm.dataPaginations[_vm.priceTables].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Bảng giá"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(scope.row.expected_txt) + "\n              ")]), _vm._v(" "), _c('p', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (scope.row.hour_apply),
                  expression: "scope.row.hour_apply"
                }]
              }, [_vm._v("\n                Giờ áp dụng: " + _vm._s(scope.row.hour_apply_txt) + "\n              ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "TP đi/đến"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.city_from) ? _c('p', [_vm._v("\n                TP đi: " + _vm._s(scope.row.city_from.data.name) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.region_to) ? _c('p', [_vm._v("\n                Vùng miền đến: " + _vm._s(scope.row.region_to.data.name) + "\n              ")]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "HVC"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.carrier) ? _c('p', [_vm._v("Tên: " + _vm._s(scope.row.carrier.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.service) ? _c('p', [_vm._v("Dịch vụ: " + _vm._s(scope.row.service.data.name))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Mapping: " + _vm._s(scope.row.mapping_txt))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Cân nặng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Khởi điểm: "), _c('span', {
                staticClass: "text-orange"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight_first)))])]), _vm._v(" "), _c('p', [_vm._v("Tối đa: "), _c('span', {
                staticClass: "text-orange"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.maximum_weight)))])]), _vm._v(" "), _c('p', [_vm._v("Bước nhảy: "), _c('span', {
                staticClass: "text-orange"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight_step)))])]), _vm._v(" "), _c('p', [_vm._v("Phí bước nhảy: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.weight_step_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Phí"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Giá: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount)))])]), _vm._v(" "), _c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.return_fee, 3)) + "\n                  " + _vm._s(_vm.priceTableHelpers.currencies[_vm.localPriceTable.return_unit]))])]), _vm._v(" "), _c('p', [_vm._v("Phụ phí ngoại thành: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.location_step_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Áp dụng:\n                "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Kiểu áp dụng phụ phí ngoại thành"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.lsf_type_txt))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "COD"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Phí COD: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("number")(scope.row.cod_fee, 3)) + " %")])]), _vm._v(" "), _c('p', [_vm._v("Phí COD tối thiểu: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_min_fee)))])]), _vm._v(" "), _c('p', [_vm._v("GTĐH áp dụng: "), _c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_apply)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('router-link', {
                staticClass: "text-orange padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'edit-price-table',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deletePriceTable(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Nhân bản"
                }
              }, [_c('router-link', {
                staticClass: "text-violet padding-all display-inline-block",
                attrs: {
                  "to": {
                    name: 'copy-price-table',
                    params: {
                      id: scope.row.id
                    }
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-files-o",
                attrs: {
                  "aria-hidden": "true"
                }
              })])], 1) : _vm._e(), _vm._v(" "), (!scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Chặn tuyến đường"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer"
              }, [_c('i', {
                staticClass: "fa fa-road",
                attrs: {
                  "aria-hidden": "true"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.filterBlock(scope.row)
                  }
                }
              })])]) : _vm._e(), _vm._v(" "), (scope.row.deleted_at) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Khôi phục"
                }
              }, [_c('a', {
                staticClass: "text-blue padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.restore(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-refresh",
                attrs: {
                  "aria-hidden": "true"
                }
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn hãng vận chuyển"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.carrier_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "carrier_id", $$v)
      },
      expression: "filters.carrier_id"
    }
  }, _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn dịch vụ"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.service_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "service_id", $$v)
      },
      expression: "filters.service_id"
    }
  }, _vm._l((_vm.services), function(service) {
    return _c('el-option', {
      key: service.id,
      attrs: {
        "label": service.name,
        "value": service.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "placeholder": "Chọn ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn TP đi"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.city_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "city_id", $$v)
      },
      expression: "filters.city_id"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn vùng miền đến"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.region_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "region_id", $$v)
      },
      expression: "filters.region_id"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.id,
      attrs: {
        "label": region.name,
        "value": region.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn TP đến"
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.city_to_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "city_to_id", $$v)
      },
      expression: "filters.city_to_id"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('select-client', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Gõ để tìm kiếm khách hàng"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.filters.apply_only_customer),
      callback: function($$v) {
        _vm.$set(_vm.filters, "apply_only_customer", $$v)
      },
      expression: "filters.apply_only_customer"
    }
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-44493a1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricetable/PriceTable.vue
// module id = 704
// module chunks = 1